import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { LuCalendarCheck, LuClipboardList } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

export const SubmenuPermitPage = () => {
  const navigate = useNavigate();
  const { setHeader } = useThemeStore((state) => state);

  useEffect(() => {
    setHeader({ buttonBack: true, filter: false, title: "Perizinan" });
  }, [setHeader]);

  return (
    <div className="tw-px-4 tw-pt-4 tw-pb-20">
      <div className="tw-px-0 card-body">
        <div className="card-body-grid">
          <div className="card-grid">
            <div onClick={() => navigate(linkPage.PERMIT_PAGE)} className="tw-m-0">
              <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-full tw-w-[46px] tw-h-[46px] tw-border-2 tw-border-background-100 tw-shadow-sm tw-bg-[#ffecec]">
                <LuCalendarCheck className="tw-text-2xl tw-text-[#ff6b6b]" />
              </div>
              <div className="tw-line-clamp-1 card-name">Request</div>
            </div>
          </div>

          <div className="card-grid">
            <div onClick={() => navigate(linkPage.PERMIT_DATA_PAGE)} className="tw-m-0">
              <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-full tw-w-[46px] tw-h-[46px] tw-border-2 tw-border-background-100 tw-shadow-sm tw-bg-[#f1f5f9]">
                <LuClipboardList className="tw-text-2xl tw-text-[#64748b]" />
              </div>
              <div className="tw-line-clamp-1 card-name">Laporan</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
